import { RadioGroupButtons } from '@cimplico/components';
import { Control, Controller, FieldValues, Path } from 'react-hook-form';

type BehaviourRadioProps<T extends FieldValues> = {
    control: Control<T>;
    name: Path<T>;
};

const options = [
    { label: 'Copy', value: 'COPY' },
    { label: 'Share', value: 'SHARE' },
];

/**
 * Radio form element that signals if a calculation template should be shared when used in a workpaper,
 * or if it should be copied on each use.
 */
function BehaviourRadioButton<T extends FieldValues>({ control, name }: BehaviourRadioProps<T>): JSX.Element {
    return (
        <Controller
            name={name}
            control={control}
            render={(render): JSX.Element => (
                <div>
                    <label className="text-sm block text-gray-700 dark:text-gray-200 font-medium mb-1">Behaviour</label>
                    <RadioGroupButtons
                        options={options}
                        value={render.field.value ?? options[1].value}
                        groupName="behaviour"
                        onChange={render.field.onChange}
                    />
                    <p className="text-xs text-gray-500 dark:text-gray-300 mt-2">
                        Setting this to copy will create a separate calculation per associated worksheet. Shared will only create one
                        calculation and apply it to all matching worksheets
                    </p>
                </div>
            )}
        />
    );
}

export default BehaviourRadioButton;
